import { LensTheme, PageHeader } from '@diligentcorp/atlas-theme-mui-lens';
import { Box, Tabs, useTheme } from '@mui/material';
import { Stack } from '@mui/system';
import React, { useState } from 'react';
import { useGetRetentionRulesCountQuery } from 'src/graphql';
import {
  useGetRulesByStatusQuery,
  useGetUpcomingRetentionActionsCountQuery,
} from '../../../../graphql/generated';
import { ThemedTab } from '../../atoms';
import {
  RetentionRules,
  UpcomingActions,
  WaitingForApproval,
} from '../../organisms';
import { RULE_STATUS } from '../../utils';

export const DataRetentionPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { data: upcomingData } = useGetUpcomingRetentionActionsCountQuery();
  const upcomingCount = upcomingData?.getUpcomingRetentionActionsCount ?? 0;
  const { data: rulesData } = useGetRetentionRulesCountQuery(undefined, {
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
  const rulesCount = rulesData?.getRetentionRulesCount || 0;
  const { data: approvalData, isLoading: approvalLoading } =
    useGetRulesByStatusQuery({
      status: RULE_STATUS.WAITING_FOR_APPROVAL,
    });
  const approvalRules = approvalData?.getRulesByStatus ?? [];
  const approvalCount = approvalRules.length;
  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
  const { tokens } = useTheme<LensTheme>();

  return (
    <Box
      sx={{
        height: '100%',
        overflow: 'scroll',
        padding: `${tokens.core.spacing[3].value} ${tokens.core.spacing[6].value}`,
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.core.spacing[4].value,
      }}
    >
      <Stack direction="column" gap={1}>
        <PageHeader pageTitle="Data retention" />
        <Tabs
          value={activeTab}
          onChange={handleChange}
          sx={{
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '1px',
              backgroundColor: tokens.semantic.color.ui.divider.default.value,
              zIndex: 0,
            },
          }}
        >
          <ThemedTab
            label="Retention rules"
            withBadge
            badgeContent={rulesCount}
          />
          <ThemedTab
            label="Upcoming actions"
            withBadge
            badgeContent={upcomingCount}
          />
          <ThemedTab
            label="Waiting for approval"
            withBadge
            badgeContent={approvalCount}
          />
        </Tabs>
      </Stack>
      {activeTab === 0 && <RetentionRules />}
      {activeTab === 1 && <UpcomingActions />}
      {activeTab === 2 && (
        <WaitingForApproval rules={approvalRules} isLoading={approvalLoading} />
      )}
    </Box>
  );
};
